module.exports = __webpack_public_path__ + "img/check.c88e63d1.svg";